import React, { useContext, useEffect, useRef, useState } from "react";
import "./PreventiveMaintinanceTable.css";
import search1 from "../../../../Components/Admin/assets/icons/search.png";
import { Row, Col, Form, Pagination, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { Context } from "../../../../utils/context";
import CustomPagination from "../../../common/CustomPagination";
import { Link } from "react-router-dom";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import {
  editStatusData,
  getDownloadDataExcel,
  postData,
} from "../../../../utils/api";
import { post } from "jquery";
import ModalSave from "../../../common/ModalSave";
import Visit_History_Modal from "../../../common/modal/visit_history_modal/Visit_History_Modal";
import ComplaintAssignEngineer from "../../../common/modal/complaint_assign_engineer/ComplaintAssignEngineer";
import SupportTransfer from "../../../common/modal/support_transfer/SupportTransfer";
import SupportTransferHistory from "../../../common/modal/support_transfer_history/SupportTransferHistory";
import AssignProductsToEngineer from "../../../common/modal/assign_products_to_engineer/AssignProductsToEngineer";
import { Select2Data } from "../../../../utils/common";
import ModalComplaintSave from "../../../common/ModalComplaintSave";

const PreventiveMaintinanceTable = () => {
  // Modal
  const [lgShow, setLgShow] = useState(false);

  const { getData, complaintstatus, setComplaintStatus } = useContext(Context);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [data, setData] = useState({ totalPages: 1, currentPage: 1 });

  const [dashboard, setDashborad] = useState({});
  const [dashboardchart, setDashboradChart] = useState({});
  const [visitStatus, setVisitStatus] = useState([]);
  const [serviceEngineer, setServiceEngineer] = useState([]);
  const [customer, setCustomer] = useState([]);

  const [reset, setReset] = useState();

  const [totalPages, settotalPages] = useState();

  const [onPageChange, setonPageChange] = useState(1);

  const [showVisitHistory, setShowVisitHistory] = useState(false);
  const [showAssignEngieer, setShowAssignEngineer] = useState(false);

  const [showTransfer, setShowTransfer] = useState(false);
  const [showTransferHistory, setShowTransferHistory] = useState(false);
  const [assignProductShow, setAssignProductShow] = useState(false);

  const [currentDate, setCurrentDate] = useState(new Date());


  const [id, setID] = useState("");
  const [pmId, setPMId] = useState("");
  const [transferPmId, setTransferPMId] = useState("");

  const GetAllVisitStatus = async () => {
    const response = await getData("/masters/allvisitstatus");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "visit_status_id",
          label: data.name,
        });
      });
    }
    setVisitStatus(option);
  };

  const GetAllServiceEngineer = async () => {
    const response = await getData("/masters/all-service-engineers");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.value,
          name: "user_id",
          label: data.label,
        });
      });
    }
    setServiceEngineer(option);
  };

  useEffect(() => {
    GetAllVisitStatus();
    GetAllServiceEngineer();
  }, []);

  const handlePageChange = (pageNumber) => {

    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}>
        {page}
      </Pagination.Item>
    );
  }

  const [customer_id, setCustomerId] = useState("");
  const [searchVisitStatus, setSearchVisitStatus] = useState("");

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const handleFromChange = (e) => {
    const fromDate = e.target.value;
    setFrom(fromDate);
  };

  const handleToChange = (e) => {
    const toDate = e.target.value;
    setTo(toDate);
  };

  const getAllData = async () => {
    {
      const res = await getData(
        `/complaint-management/preventive-maintainance?page=${onPageChange}&per_page=${perPage}&customer_id=${
          customer_id?.value || ""
        }&visit_status_id=${searchVisitStatus?.value || ""}&from=${
          from || ""
        }&to=${to || ""}&month=${currentDate}`
      );
      setData(res?.data);
      setCurrentPage(res?.data?.currentPage);
      setPerPage(res?.data?.per_page);
      settotalPages(res?.data?.totalPages);
    }
    {
      const res = await getData(
        `/complaint-management/preventive-maintainance/dashboardData?month=${currentDate}`
      );
      setDashborad(res?.data);
    }

    const res3 = await getData("/masters/all-customers");

    if (res3?.success) {
      setCustomer(await Select2Data(res3?.data));
    }

    {
      const res = await getData(`/complaint-management/dashboard/chart`);
      setDashboradChart(res?.data?.records);
   
    }
  };

  useEffect(() => {
    getAllData();
  }, [
    currentPage,
    search,
    lgShow,
    onPageChange,
    customer_id,
    reset,
    searchVisitStatus,
    from,
    to,
    currentDate,
  ]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const ChangeStatus = async (id, data) => {
    const response = await postData(
      `/complaint-management/preventive-maintainance/change-status/${id}`,
      data
    );

    if (response.success) {
      setShowModal({ code: response.code, message: response.message });
      setTimeout(() => {
        getAllData();
        setShowModal(0);
      }, 2000);
    } else {
      setShowModal({ code: response.code, message: response.message });
      setTimeout(() => setShowModal(0), 2000);
    }
  };

  const HandleDownload = async () => {
    try {
      await getDownloadDataExcel(
        `/complaint-management/preventive-maintainance/download?month=${currentDate}`,
        "",
        `${currentDate.toLocaleString("en-US", {
          month: "short",
        })}-${currentDate.getFullYear()} Preventive Maintainance List`
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };

  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  return (
    <>
      <section className="dashboard-section">
        <div className="top-center-text">
          <div className="top-center-text d-flex align-items-center gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={handlePrevMonth}>
              ◀
            </button>

            <p className="mb-0 fw-semibold">
              {currentDate.toLocaleString("en-US", { month: "short" })} -{" "}
              {currentDate.getFullYear()}
            </p>

            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={handleNextMonth}>
              ▶
            </button>
          </div>
        </div>
        <br></br>
        <div className="row me-0 ms-0">
          <div className="dashboard-main">
            <div className="card-section">
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={3}
                  xxl={3}
                  className="custom_col">
                  <Link
                    // to="/complaint-list-table"
                    onClick={() =>
                      setComplaintStatus({ value: 1, label: "New" })
                    }>
                    <div className="main-cards clr1 mb-xxxl-0 mb-xl-0 mb-lg-3">
                      <div className="conts">
                        <div className="left-conts">
                          <p className="cont-top-text">Total Customer</p>
                          <h4 className="cont-no">{dashboard?.all_customer}</h4>
                        </div>
                        <div className="right-conts">
                          <img
                            className="ticket-img"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/tickets.png"
                            }
                          />
                          {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                        </div>
                      </div>
                      {/* <div className="bottom-conts">
                        <p className="cont-text">
                          View Complaints{" "}
                          <FontAwesomeIcon
                            icon="fa-solid fa-greater-than"
                            className="arrow"
                          />
                        </p>
                      </div> */}
                    </div>
                  </Link>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={3}
                  xxl={3}
                  className="custom_col">
                  <Link
                    // to="/complaint-list-table"
                    onClick={() =>
                      setComplaintStatus({ value: 2, label: "Hold" })
                    }>
                    <div className="main-cards clr2 mb-xxxl-0 mb-xl-0 mb-lg-3">
                      <div className="conts">
                        <div className="left-conts">
                          <p className="cont-top-text">New Visits</p>
                          <h4 className="cont-no"> {dashboard?.new_visit}</h4>
                        </div>
                        <div className="right-conts">
                          <img
                            className="ticket-img"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/tickets.png"
                            }
                          />
                          {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                        </div>
                      </div>
                      {/* <div className="bottom-conts">
                        {" "}
                        <p className="cont-text">
                          View Complaints{" "}
                          <FontAwesomeIcon
                            icon="fa-solid fa-greater-than"
                            className="arrow"
                          />
                        </p>
                      </div> */}
                    </div>
                  </Link>
                </Col>

                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={3}
                  xxl={3}
                  className="custom_col">
                  <Link
                    // to="/complaint-list-table"
                    onClick={() =>
                      setComplaintStatus({ value: 4, label: "Rejected" })
                    }>
                    <div className="main-cards clr4 mb-xxxl-0 mb-xl-0 mb-lg-3">
                      <div className="conts">
                        <div className="left-conts">
                          <p className="cont-top-text">Assigned Visits</p>
                          <h4 className="cont-no">{dashboard?.assign_visit}</h4>
                        </div>
                        <div className="right-conts">
                          <img
                            className="ticket-img"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/tickets.png"
                            }
                          />
                          {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                        </div>
                      </div>
                      {/* <div className="bottom-conts">
                        {" "}
                        <p className="cont-text">
                          View Complaints{" "}
                          <FontAwesomeIcon
                            icon="fa-solid fa-greater-than"
                            className="arrow"
                          />
                        </p>
                      </div> */}
                    </div>
                  </Link>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={3}
                  xxl={3}
                  className="custom_col">
                  <Link
                    // to="/complaint-list-table"
                    onClick={() =>
                      setComplaintStatus({ value: 3, label: "Resolved" })
                    }>
                    <div className="main-cards clr3 mb-xxxl-0 mb-xl-0 mb-lg-3">
                      <div className="conts">
                        <div className="left-conts">
                          <p className="cont-top-text">Pending Visits</p>
                          <h4 className="cont-no">
                            {" "}
                            {dashboard?.pending_visit}
                          </h4>
                        </div>
                        <div className="right-conts">
                          <img
                            className="ticket-img"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/tickets.png"
                            }
                          />
                          {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                        </div>
                      </div>
                      {/* <div className="bottom-conts">
                        {" "}
                        <p className="cont-text">
                          View Complaints{" "}
                          <FontAwesomeIcon
                            icon="fa-solid fa-greater-than"
                            className="arrow"
                          />
                        </p>
                      </div> */}
                    </div>
                  </Link>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={3}
                  xxl={3}
                  className="custom_col">
                  <Link
                    // to="/complaint-list-table"
                    onClick={() =>
                      setComplaintStatus({ value: 4, label: "Rejected" })
                    }>
                    <div className="main-cards clr5 mb-xxxl-0 mb-xl-0 mb-lg-3">
                      <div className="conts">
                        <div className="left-conts">
                          <p className="cont-top-text">Completed Visits</p>
                          <h4 className="cont-no">
                            {dashboard?.completed_visit}
                          </h4>
                        </div>
                        <div className="right-conts">
                          <img
                            className="ticket-img"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/tickets.png"
                            }
                          />
                          {/* <FontAwesomeIcon icon="fa-solid fa-envelope-open-text " className='iconses' /> */}
                        </div>
                      </div>
                      {/* <div className="bottom-conts">
                        {" "}
                        <p className="cont-text">
                          View Complaints{" "}
                          <FontAwesomeIcon
                            icon="fa-solid fa-greater-than"
                            className="arrow"
                          />
                        </p>
                      </div> */}
                    </div>
                  </Link>
                </Col>
              </Row>
            </div>

            <div className="bar-section">
              <div className="bar-main">
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <div className="bar-div"></div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          <div className="tables-sections">
            <div className="table-mains">
              <div className="table-top-main">
                <div className="top-left-text">
                  <p>This Month Data</p>
                </div>
                <div className="top-right-text">
                  {/* <div className="">
                        <Link to="/complaint-list-table">
                          {" "}
                          <p>View all</p>
                        </Link>
                      </div> */}
                </div>
              </div>

              <Row className="p-3">
                <Col xl={3} lg={3} md={5} sm={12}>
                  <Form.Label>Customer</Form.Label>
                  <Select
                    placeholder="customer"
                    className="custom-select"
                    onChange={(e) => {
                      setCustomerId(e);
                      setonPageChange(1);
                    }}
                    value={customer_id}
                    options={customer}
                  />
                </Col>

                <Col xl={3} lg={3} md={5} sm={12}>
                  <Form.Label>Visit Status</Form.Label>
                  <Select
                    placeholder="Status"
                    className="custom-select"
                    onChange={(e) => {
                      setSearchVisitStatus(e);
                      setonPageChange(1);
                    }}
                    value={searchVisitStatus}
                    options={visitStatus}
                  />
                </Col>

                <Col xl={2} lg={3} md={5} sm={12}>
                  <Form.Label> Schedule From</Form.Label>
                  <input
                    type="date"
                    className="form-control"
                    value={from}
                    onChange={handleFromChange}
                  />
                </Col>
                <Col xl={2} lg={3} md={5} sm={12}>
                  <Form.Label> Schedule To</Form.Label>
                  <input
                    type="date"
                    className="form-control"
                    value={to}
                    onChange={handleToChange}
                    min={from} // Set the minimum allowed date for "To" as the "From" date
                  />
                </Col>
                <Row>
                  <Col xl={3} lg={3} md={2} sm={6}>
                    <Form.Label></Form.Label>
                    <div className="Search-1 ">
                      <button
                        type="button"
                        onClick={() => {
                          setCustomerId("");
                          setSearchVisitStatus("");
                          setFrom("");
                          setTo("");
                          setReset(!reset);
                        }}
                        className="view_btn  btn btn-danger">
                        Reset
                      </button>
                    </div>
                  </Col>
                  <Col xl={3} lg={3} md={8} sm={6} className="my-auto">
                    <Form.Label>
                      <div className="Search-1 ">
                        <button
                          className="view_btn  btn btn-danger"
                          onClick={HandleDownload}>
                          Download data in Excel &nbsp;
                          <FontAwesomeIcon
                            icon="fa-solid fa-file-lines "
                            // className="pdf-icon"
                            // variant="success"
                          />
                        </button>
                      </div>
                    </Form.Label>
                  </Col>
                </Row>
              </Row>

              <div className="table-sec-main">
                <Table responsive hover>
                  <thead>
                    <tr className="heads-main">
                      {/* <th>Sr.No</th> */}
                      <th>Customer Name</th>
                      {/* <th>End Month</th> */}
                      <th>Visit Status</th>
                      <th>Visit Date</th>
                      <th>Schedule Time</th>
                      <th>Completion Date</th>
                      {/* <th>Assigned Engineer</th> */}
                      {/* <th>Expected Visit Date</th> */}
                      <th>Assign Engineer</th>
                      <th>Transfer To Another Engineer</th>
                      <th>Change Visit Status</th>
                      {/* <th>Support Transfer History</th> */}
                      <th>View History</th>
                      <th>View Product Status</th>
                    </tr>
                  </thead>
                  <tbody className="table-body-holder">
                    {data?.data?.map((d, index) => (
                      <tr className="heads-main" key={index}>
                        {/* <td>{index + 1}</td> */}
                        <td>{d.customer?.name}</td>
                        <td>{d.visit_status?.name}</td>
                        <td>{d?.engineer_visit_date || "-"}</td>
                        <td>{d?.schedule_time || "-"}</td>
                        <td>{d?.completion_date || "-"}</td>
                        <td style={{ minWidth: "200px" }}>
                          {d?.user_id ? (
                            d?.user?.name
                          ) : (
                            <button
                              className="view_btn"
                              onClick={() => {
                                setShowAssignEngineer(true);
                                setPMId(d?.id);
                              }}>
                              Assign Engineer
                            </button>
                          )}
                        </td>

                        <td style={{ minWidth: "200px" }}>
                          {d?.visit_status_id == 4 ? (
                            "Visit Done"
                          ) : d?.user_id ? (
                            <button
                              className="view_btn"
                              onClick={() => {
                                setShowTransfer(true);
                                setPMId(d?.id);
                              }}>
                              Transfer
                            </button>
                          ) : (
                            "-"
                          )}
                        </td>

                        <td style={{ minWidth: "200px" }}>
                          {d?.visit_status_id == 4 ? (
                            "Completed"
                          ) : (
                            <Select
                              name="country_id"
                              className="input-mandatory"
                              onChange={(selectedOption) =>
                                ChangeStatus(d.id, {
                                  visit_status_id: selectedOption?.value,
                                })
                              }
                              options={visitStatus}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          )}
                        </td>

                        {/* <td style={{ minWidth: "200px" }}>
                          {
                            <button
                              className="view_btn"
                              onClick={() => {
                                setTransferPMId(d?.id);
                                setShowTransferHistory(true);
                              }}>
                              Transfer History
                            </button>
                          }
                        </td> */}

                        <td>
                          <button
                            className="view_btn"
                            onClick={() => {
                              setID(d.customer_id);
                              setShowVisitHistory(true);
                            }}>
                            View
                          </button>
                        </td>

                        <td>
                          <button
                            className="view_btn"
                            onClick={() => {
                              setID(d.id);
                              setAssignProductShow(true);
                            }}>
                            Product Status
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="paginationss">
                  <Pagination_Holder
                    onPageChange={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ModalComplaintSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Visit_History_Modal
        show={showVisitHistory}
        id={id}
        onHide={() => {
          setShowVisitHistory(false);
        }}
      />
      <ComplaintAssignEngineer
        show={showAssignEngieer}
        id={pmId}
        getAllData={getAllData}
        onHide={() => {
          setShowAssignEngineer(false);
        }}
      />

      <SupportTransfer
        show={showTransfer}
        id={pmId}
        getAllData={getAllData}
        onHide={() => {
          setShowTransfer(false);
        }}
      />

      <SupportTransferHistory
        show={showTransferHistory}
        id={transferPmId}
        getAllData={getAllData}
        onHide={() => {
          setShowTransferHistory(false);
        }}
      />

      <AssignProductsToEngineer
        show={assignProductShow}
        id={id}
        getAllData={getAllData}
        onHide={() => {
          setAssignProductShow(false);
        }}
      />
    </>
  );
};

export default PreventiveMaintinanceTable;
